import { render } from "./PolicyInfo.vue?vue&type=template&id=8ae10d4e&scoped=true"
import script from "./PolicyInfo.vue?vue&type=script&lang=js"
export * from "./PolicyInfo.vue?vue&type=script&lang=js"

import "./PolicyInfo.vue?vue&type=style&index=0&id=8ae10d4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ae10d4e"]])

export default __exports__